import React from 'react';

const DomainModal = ({
    isEditing,
    currentDomain,
    handleDomainChange,
    handleSubmit,
    handleIPChange,
    currentIP,
    handleAddIP,
    handleRemoveIP,
    handleEmailChange,
    currentEmail,
    handleAddEmail,
    handleRemoveEmail,
    setShowModal
}) => (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-500 bg-opacity-75 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-lg font-medium text-gray-900">
                    {isEditing ? 'Edit Domain' : 'Add New Domain'}
                </h3>
                <button
                    type="button"
                    className="text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={() => setShowModal(false)}
                >
                    <span className="sr-only">Close</span>
                    <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <form onSubmit={handleSubmit} className="px-6 py-4">
                <div className="mb-4">
                    <label htmlFor="domain" className="block text-sm font-medium text-gray-700 mb-1">
                        Domain Name
                    </label>
                    <input
                        id="domain"
                        type="text"
                        name="domain"
                        value={currentDomain.domain}
                        onChange={handleDomainChange}
                        placeholder="example.com"
                        required
                        className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                </div>

                {/* IP Addresses section */}
                <div className="mt-6 border-t border-gray-200 pt-4">
                    <h4 className="text-base font-medium text-gray-900 mb-3">IP Addresses</h4>

                    {currentDomain.ipAddresses.length > 0 && (
                        <div className="mb-4 border rounded-md p-3 max-h-40 overflow-y-auto bg-gray-50">
                            {currentDomain.ipAddresses.map((ip, index) => (
                                <div key={`ip-${index}`} className="flex justify-between items-center py-2 px-3 bg-white rounded shadow mb-2">
                                    <span className="text-sm text-gray-700">{ip}</span>
                                    <button
                                        type="button"
                                        className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded hover:bg-red-200 focus:outline-none"
                                        onClick={() => handleRemoveIP(index)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="flex items-end gap-2">
                        <div className="flex-grow">
                            <label htmlFor="ipAddress" className="block text-sm font-medium text-gray-700 mb-1">
                                New IP Address
                            </label>
                            <input
                                id="ipAddress"
                                type="text"
                                value={currentIP}
                                onChange={handleIPChange}
                                placeholder="192.168.1.1"
                                className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <button
                            type="button"
                            onClick={handleAddIP}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        >
                            Add IP
                        </button>
                    </div>
                </div>

                {/* Email Addresses section */}
                <div className="mt-6 border-t border-gray-200 pt-4">
                    <h4 className="text-base font-medium text-gray-900 mb-3">Email Addresses</h4>

                    {currentDomain.emails && currentDomain.emails.length > 0 && (
                        <div className="mb-4 border rounded-md p-3 max-h-40 overflow-y-auto bg-gray-50">
                            {currentDomain.emails.map((email, index) => (
                                <div key={`email-${index}`} className="flex justify-between items-center py-2 px-3 bg-white rounded shadow mb-2">
                                    <span className="text-sm text-gray-700">{email}</span>
                                    <button
                                        type="button"
                                        className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded hover:bg-red-200 focus:outline-none"
                                        onClick={() => handleRemoveEmail(index)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="flex items-end gap-2">
                        <div className="flex-grow">
                            <label htmlFor="emailAddress" className="block text-sm font-medium text-gray-700 mb-1">
                                New Email Address
                            </label>
                            <input
                                id="emailAddress"
                                type="email"
                                value={currentEmail}
                                onChange={handleEmailChange}
                                placeholder="admin@example.com"
                                className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <button
                            type="button"
                            onClick={handleAddEmail}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        >
                            Add Email
                        </button>
                    </div>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={() => setShowModal(false)}
                        className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        {isEditing ? 'Update Domain' : 'Add Domain'}
                    </button>
                </div>
            </form>
        </div>
    </div>
);

export default React.memo(DomainModal);